import {
  defineComponents,
  DocumentReaderService,
  InternalScenarios,
  Result,
} from '@regulaforensics/vp-frontend-document-components';

let initPromise: Promise<void> | null = null;

const resultTypeOutput = [
  Result.STATUS,
  Result.TEXT,
  Result.DOCUMENT_TYPE,
  Result.DOCUMENT_IMAGE,
  Result.IMAGES,
];

export const ensureRegulaSdkInitialized = (): Promise<void> => {
  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    window.RegulaDocumentSDK = new DocumentReaderService();

    window.RegulaDocumentSDK.recognizerProcessParam = {
      processParam: {
        scenario: InternalScenarios.MrzAndLocate,
        resultTypeOutput,
        noGraphics: false,
      },
    };
    window.RegulaDocumentSDK.imageProcessParam = {
      processParam: {
        scenario: InternalScenarios.MrzAndLocate,
        resultTypeOutput,
        noGraphics: false,
      },
    };

    await defineComponents();

    const devLicense = import.meta.env.VITE_REGULA_LICENSE_KEY as string | undefined;
    await window.RegulaDocumentSDK.initialize(
      import.meta.env.PROD || !devLicense ? undefined : { license: devLicense }
    );
  })();

  return initPromise;
};
